import type { Ref } from 'vue';
import { ref } from 'vue';
import { resolveNetwork } from '@/api/helpers/resolveNetwork';
import type { NetworkLocateModel } from '@/types/network';
import { useNetworkStore } from '@/store';

type UseNetworkSettings = {
  readonly isLoading: Ref<boolean>;
  readonly settings: Ref<NetworkLocateModel | null>;
  readonly error: Ref<string | null>;
  check(uri: string): Promise<NetworkLocateModel | null>;
  clear(): void;
};

export function useNetworkSettings(): UseNetworkSettings {
  const isLoading = ref(false);
  const settings = ref<NetworkLocateModel | null>(null);
  const error = ref<string | null>(null);

  async function check(uri: string): Promise<NetworkLocateModel | null> {
    isLoading.value = true;
    const res = await resolveNetwork(uri, useNetworkStore().getLocate);
    settings.value = res.settings;
    error.value = res.error;
    isLoading.value = false;
    return res.settings;
  }

  function clear(): void {
    settings.value = null;
    error.value = null;
  }

  return {
    get isLoading() {
      return isLoading;
    },
    get settings() {
      return settings;
    },
    get error() {
      return error;
    },
    check,
    clear,
  };
}
